import React, { useState } from 'react';
import { sendEmail } from '../services/emailService';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    sendEmail({
      from_name: form.name,
      from_email: form.email,
      phone: form.phone,
      subject: 'New Contact Form Submission - EGB Systems',
      message: form.message,
    }).then(() => {
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
      setForm({ name: '', email: '', phone: '', message: '' });
    }).catch(() => {
      alert('Failed to send message. Please try again or email us directly at support@egbsystems.com');
    });
  };

  return (
    <>
      <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
        <div className="container py-4">
          <h1 className="fw-bold">Contact Us</h1>
          <p className="lead" style={{ color: '#cbd5e1' }}>Get in touch with our team</p>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="row g-5">
            <div className="col-12 col-lg-5">
              <h3 className="fw-bold mb-4">Let's Build Something Great Together</h3>
              <p className="text-muted mb-4">Ready to transform your business? Our team will respond within 24 hours.</p>

              {[
                { icon: '🇺🇸', title: 'USA Office', lines: ['1010 Summer Street, Suite 102, 1st Floor', 'Stamford, Connecticut – 06905', 'Tel: 203 653 2741 | Fax: 866 693 5396'], map: 'https://maps.app.goo.gl/TCRZS8YZnBDV4ABv8' },
                { icon: '🇮🇳', title: 'India Office', lines: ['135/1, L-Block 17th Street', 'Anna Nagar, Chennai, Tamil Nadu – 600102', 'Tel: +91 044-35510504'], map: 'https://share.google/nZGUW4GoJWjaTqxFk' },
                { icon: '✉️', title: 'Email', lines: ['support@egbsystems.com'] },
              ].map(item => (
                <div key={item.title} className="d-flex gap-3 mb-4">
                  <div className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 44, height: 44, background: '#dbeafe', fontSize: 20 }}>{item.icon}</div>
                  <div>
                    <div className="fw-bold small mb-1">{item.title}</div>
                    {item.lines.map(line => <div key={line} className="text-muted small">{line}</div>)}
                    {item.map && <a href={item.map} target="_blank" rel="noopener noreferrer" className="small text-primary">View on Google Maps →</a>}
                  </div>
                </div>
              ))}
            </div>

            <div className="col-12 col-lg-7">
              <div className="card border-0 shadow p-4 rounded-4">
                {submitted ? (
                  <div className="text-center py-5">
                    <div style={{ fontSize: 48 }}>✅</div>
                    <h4 className="fw-bold mt-3">Message Sent!</h4>
                    <p className="text-muted">We'll get back to you within 24 hours.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-semibold small">Name *</label>
                        <input type="text" className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your Name" required />
                      </div>
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-semibold small">Email *</label>
                        <input type="email" className="form-control" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" required />
                      </div>
                      <div className="col-12">
                        <label className="form-label fw-semibold small">Phone Number</label>
                        <input type="tel" className="form-control" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="+1 (203) 000-0000" />
                      </div>
                      <div className="col-12">
                        <label className="form-label fw-semibold small">Message</label>
                        <textarea className="form-control" rows={5} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Tell us about your project..." required></textarea>
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-primary w-100 py-3 fw-bold">Send Message →</button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
